export default __webpack_public_path__ + "static/media/EDISON-Workshop-31-May-2018-Denmark.2a137344.md";